import React, { useCallback } from 'react';
import ReactModal from 'react-modal';
import { withContext } from 'recompose';
import PropTypes from 'prop-types';
import { CLASSNAME_PREFIX } from '../../componentConfig';
import './Modal.scss';

var COMPONENT_CLASSNAME = CLASSNAME_PREFIX + '-modal';

var Modal = function Modal(_ref) {
  var visible = _ref.visible,
      url = _ref.url,
      onClose = _ref.onClose,
      modalId = _ref.modalId;

  if (!visible) {
    return null;
  }

  var onRequestClose = useCallback(function () {
    onClose();
  }, [onClose]);

  return React.createElement(
    ReactModal,
    {
      ariaHideApp: false,
      className: COMPONENT_CLASSNAME + ' ' + COMPONENT_CLASSNAME + '--' + modalId,
      'data-test-handler': '@myaccount/modal',
      isOpen: visible,
      onRequestClose: onRequestClose,
      overlayClassName: COMPONENT_CLASSNAME + '__overlay',
      portalClassName: 'sb',
      shouldCloseOnOverlayClick: true
    },
    React.createElement(
      'div',
      { className: COMPONENT_CLASSNAME + '__wrapper' },
      React.createElement('iframe', {
        'data-test-handler': '@myaccount/modal.iframe',
        className: COMPONENT_CLASSNAME + '__iframe',
        src: url,
        title: 'myaccount-modal-iframe'
      })
    )
  );
};

export default withContext({ t: PropTypes.func }, function () {
  return { t: function t() {
      return function (key) {
        return key;
      };
    } };
})(Modal);